<template>
  <div class="animation scroll">
    <div class="container">
      <div class="animation-nav1 fl clearfix">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="教程名称">
            <el-input
              v-model="formInline.name"
              placeholder="教程关键字"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="animation-bottom1 fl clearfix">
        <div class="push-left fl">
          <ul>
            <template v-for="(item, index) in videos">
              <li v-bind:key="index">
                <video class="video" controls="controls" :src="item.src">
                  <!-- <source

                    type="video/mp4"
                  > -->
                </video>
                <p>{{ item.name }}</p>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <el-footer height="40px" style="border-top: 1px solid #efefef">
      <div style="text-align: center;">
        <pagination ref="page" @getPage="getPage"></pagination>
      </div>
    </el-footer>
  </div>
</template>

<script>
import pagination from "./page";
export default {
  name: "VideoList",
  components: { pagination },
  data() {
    return {
      formInline: {
        name: "",
        limit: 20,
        page: 1
      },
      originVideos: [],
      videos: [
        {
          name: "Andon系统的使用方法",
          src: "http://www.w3school.com.cn/i/movie.mp4"
        }
      ]
    };
  },
  mounted() {
    this.$refs.page.getData({ totalCount: this.videos.length });
    this.originVideos = this.videos;
  },
  watch: {},
  methods: {
    onSubmit() {
      let name = this.formInline.name;
      let data = [];

      if (name == "" || name == undefined) {
        this.videos = this.originVideos;
      } else {
        this.originVideos.forEach(element => {
          if (element.name.indexOf(name) != -1) {
            data.push(element);
          }
        });
        this.videos = data;
      }
      this.$refs.page.getData({ totalCount: this.videos.length });
    },
    queryList() {
      let getData = res => {
        this.copyList = this.$common.copyData(res.data.list); // 备份原始文件
        this.$refs.page.getData(res.data);
        this.formData = res.data.parameter;
        this.$refs.onetable.$el.style.width =
          "99.9" + (Math.random() * 10).toFixed(0) + "%";
      };
      this.$getData();
    },
    // 分页
    getPage(val) {
      this.formInline.limit = val.pageSize;
      this.formInline.page = val.currentPage;
      this.queryList();
    }
  }
};
</script>

<style lang="stylus" scoped>
ul {
  list-style: none;
}

.h1 {
  padding-top: 5rem;
  color: #333333;
  font-size: 1.9rem;
  line-height: 0.9rem;
  letter-spacing: 0rem;
}

.text-p {
  padding-top: 2rem;
  font-size: 0.9rem;
  line-height: 1.3rem;
  letter-spacing: 0rem;
  color: #666666;
}

.container {
  text-align: center;
  margin-top: 50px;
}

/* 动画 开始 */
.animation-nav1 {
  width: 1175px;
}

.animation-nav1 svg {
  width: 62px;
  height: 38px;
  vertical-align: middle;
  transform: translateY(-5px);
}

.animation .steaming-nav {
  margin-bottom: 50px;
}

.animation .animation-nav1 .right a:nth-child(2) {
  margin-right: 0;
  border: 1px solid #cdcdcd;
}

.animation-bottom1 {
  width: 100%;
}

.animation-bottom1 li div span:last-child {
  position: absolute;
  /* display: none; */
  right: 8px;
  bottom: 8px;
  width: 28px;
  height: 28px;
  /* //  background-image: url(../images/img-hover.png); */
  background-color: #000;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0;
  transform-style: all 0.3s;
}

.animation-bottom1 li:hover div span {
  display: none;
}

.animation-bottom1 li:hover div span:last-child {
  opacity: 1;
  display: block;
}

.push-left li {
  float: left;
  margin-right: 11px;
}

.push-left li div {
  position: relative;
}

.push-left li p {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  width: 205px;
  height: 50px;
  line-height: 23px;
  font-size: 14px;
}

.push-left li p:hover {
  color: rgb(0, 161, 214);
}

.push-left li video {
  width: 300px;
  height: 200px;
}

.push-left div span {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #fff;
}

.push-left div span:nth-child(2) {
  left: 8px;
  font-size: 12px;
}

.push-left li span {
  display: inline-block;
}

.push-left li a:nth-child(2) {
  color: #999999;
  font-size: 12px;
}

.push-left li a:nth-child(2) i {
  display: inline-block;
  border: 1px solid #999;
  margin-right: 4px;
  margin-top: 5px;
}

.push-left li a:nth-child(2):hover {
  color: rgb(0, 161, 214);
}

.push-left li a:nth-child(2):hover i {
  border: 1px solid rgb(0, 161, 214);
}
</style>



// WEBPACK FOOTER //
// src/pages/video/components/VideoList.vue